<template>
    <div>
        <div class="p-3 bg-dark text-white">
            <input class="col-lg-2 col-md-2 col-sm-2 col-2 form-control mr-sm-2 mr-2 mb-2" type="text" :placeholder="'Código'" v-model="codigo" @keyup.enter="buscar" oninput="this.value = this.value.toUpperCase()">
            <input class="col-lg-2 col-md-2 col-sm-2 col-2 form-control mr-sm-2 mr-2 mb-2" type="text" :placeholder="'Apellido paterno'" v-model="ap" @keyup.enter="buscar" oninput="this.value = this.value.toUpperCase()">
            <input class="col-lg-2 col-md-2 col-sm-2 col-2 form-control mr-sm-2 mr-2 mb-2" type="text" :placeholder="'Apellido materno'" v-model="am" @keyup.enter="buscar" oninput="this.value = this.value.toUpperCase()">
            <input class="col-lg-2 col-md-2 col-sm-2 col-2 form-control mr-sm-2 mr-2 mb-2" type="text" :placeholder="'Nombre'" v-model="nombre" @keyup.enter="buscar" oninput="this.value = this.value.toUpperCase()">
            <button class="col-lg-1 col-md-2 col-sm-2 col-3 form-control btn btn-outline-success" @click="buscar">Buscar</button>
        </div>
        <Table/>
    </div>
</template>

<script>
import Table from '@/components/Table.vue'
export default {
    name:'Search',
    components:{
        Table
    },
    data() {
        return {
            datos: require('./../../public/codigos.json'),
            codigo:"",
            ap:"",
            am:"",
            nombre:"",
        }
    },
    methods:{
        buscar(){
            this.$store.state.validos = []
            for (let i=0;i<this.datos.length;i++){
                if(this.datos[i].codigo.slice(0,this.codigo.length) == this.codigo
                && this.datos[i].ap.slice(0,this.ap.length) == this.ap
                && this.datos[i].am.slice(0,this.am.length) == this.am
                && this.datos[i].nombre.slice(0,this.nombre.length) == this.nombre) this.$store.state.validos.push(this.datos[i])
            }
            for(let [index,value] of this.$store.state.validos.entries()){
                this.$store.state.validos[index].id = index+1
                this.$store.state.validos[index].imgUrl = "https://www.orce.uni.edu.pe/fotosuni/0060"+this.$store.state.validos[index].codigo+".jpg"
            }
            this.codigo = ""
            this.ap = ""
            this.am = ""
            this.nombre = ""
        }
    }
}
</script>

<style>

</style>